import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { useAuth } from "../../contexts/AuthContext";
import { TOKEN_STATS } from "./homeContent";
import { Body, Cta, H2, H3, Inner, Kicker, Lead, Section, alpha, useHomeTokens } from "./primitives";

/**
 * #token — "Own a piece of the platform" (the BB token).
 *
 * MEMBER-ONLY. Self-gates on login and renders nothing for the public, exactly
 * like `AdminModuleLinks`. "Investment opportunity", "profit distributions" and
 * "ground floor" are financial-product language in Australia and neither
 * /terms nor /privacy covers the token (Tom, 2026-09-06). The anchor `#token`
 * therefore does not exist on the logged-out page.
 */
export const Token = () => {
  const t = useHomeTokens();
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return null;
  return (
    <Section
      id="token"
      alt
      sx={{
        "@keyframes homeDrift": {
          from: { transform: "translate3d(-12%, 0, 0)" },
          to: { transform: "translate3d(12%, 0, 0)" },
        },
        "@media (prefers-reduced-motion: reduce)": { "& *": { animation: "none !important" } },
      }}
    >
      <Box
        position="absolute"
        top="-30%"
        left="-20%"
        right="-20%"
        h="800px"
        pointerEvents="none"
        bg={`radial-gradient(45% 45% at 50% 40%, ${alpha(t.primary, 0.13)} 0%, transparent 70%)`}
        animation="homeDrift 30s ease-in-out infinite alternate"
      />
      <Inner>
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={{ base: "40px", lg: "56px" }}>
          <Flex direction="column" gap="20px">
            <Kicker>Investment opportunity</Kicker>
            <H2>Own a piece of the platform</H2>
            <Lead>
              Dr Thomas Miller has invested thousands of hours building the infrastructure that powers dozens of tenant
              businesses — the email systems, module architecture, AI integration and continuous development that
              benefits everyone.
            </Lead>
            <Lead>
              The Business Builder Token creates a fair system: founder allocation recognises the IP investment,
              investors participate in monthly profit distributions, and governance runs transparently through Snapshot
              voting.
            </Lead>
            <Lead>One unified token — earn it through contribution, buy it directly, redeem it as bill discounts.</Lead>
          </Flex>

          <Flex direction="column" gap="14px">
            <SimpleGrid columns={2} gap="12px">
              {TOKEN_STATS.map((k) => (
                <Box key={k.title} p="22px" borderRadius="16px" borderWidth="1px" borderColor={t.cardBorder} bg={t.cardTint} minW={0}>
                  <Text fontSize="1.05rem" fontWeight="600" color={t.text} mb="6px">
                    {k.title}
                  </Text>
                  <Body fontSize=".85rem" lineHeight="1.5" color={t.textMuted}>
                    {k.body}
                  </Body>
                </Box>
              ))}
            </SimpleGrid>
            <Flex
              direction="column"
              gap="14px"
              p="30px"
              borderRadius="20px"
              borderWidth="1px"
              borderColor={alpha(t.primary, 0.3)}
              bg={`linear-gradient(135deg, ${alpha(t.primary, 0.13)} 0%, ${alpha(t.bg, 0.7)} 100%)`}
            >
              <H3 fontSize="1.3rem">🚀 The train is leaving the station</H3>
              <Body fontSize=".95rem" color={t.textSoft}>
                Limited BB tokens available · Monthly cashflow distributions · Governance rights · Ground floor
                opportunity
              </Body>
              <Cta
                to="/businessbuilder/interest"
                alignSelf="flex-start"
                title="Opens the Business Builder interest form — registers your interest in BB tokens; nothing is purchased."
              >
                Express interest
              </Cta>
            </Flex>
          </Flex>
        </SimpleGrid>
      </Inner>
    </Section>
  );
};
